import { HtmlUpdateWidgetController } from '../WidgetController';
export class InterestingWidgetController extends HtmlUpdateWidgetController {
    protected install() {
        this.autoUpdate();
    }

    protected updateHtml(
        beforeUpdateData: any,
        html: any,
        successResponse: any
    ): void {}

    protected beforeUpdate() {}

    protected afterUpdate(
        beforeUpdateData: any,
        html: any,
        successResponse: any
    ) {
        super.afterUpdate(beforeUpdateData, html, successResponse);
    }
}
